import { useCustomQuery } from "@/hooks/useCustomQuery"
import DetailAvatar from "@/components/Avatar/DetailAvatar"
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  IconButton,
  Divider,
} from "@mui/material"
import { useParams, Link } from "react-router-dom"
import { useState, useEffect } from "react"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import LetterAvatar from "@/components/Avatar/LetterAvatar"
import { DetailTable } from "@/components/Tables/DetailTable"
import { columns } from "@/pages/products/Columns"

const StoreDetails = () => {
  const { id } = useParams()

  const {
    data: response,
    isLoading,
    isError,
    error,
  } = useCustomQuery(["store-detail", id], `stores/${id}`)

  if (isLoading) {
    return <div>Loading...</div>
  }

  const store = response?.data

  return (
    <div>
      <div className="breadcrumb-card">
        <h5>Store Details</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="//">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>
            <Link to="/stores">Stores</Link>
          </li>
          <li>{store.code}</li>
        </ul>
      </div>
      {store ? (
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-4 xxl:tw-grid-cols-5 tw-gap-6">
          <div className="card bg-white border-0 px-4 rounded-3 mb-4 lg:col-span-3 xxl:col-span-4">
            <p className="my-5 text-base font-semibold text-black">Products</p>

            <CrudProvider>
              <StoreTable />
            </CrudProvider>
          </div>
          <div className="card bg-white border-0 ps-5 rounded-3 mb-4">
            <div className="card-body p-4">
              <div className="flex align-items-center mb-3 mb-lg-4">
                <div className="flex align-items-center">
                  <DetailAvatar name={store.name} />
                </div>
              </div>

              <div className="mb-3">
                <p>Brand Name:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {store.brand_name ? store.brand_name : "N/A"}
                </span>
              </div>

              <div className="mb-3">
                <p>Store Id:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {store.id}
                </span>
              </div>

              <div className="mb-3">
                <p>{store.vat_pan_type == 1 ? "Pan Number" : "Vat Number"}</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {store.pan_number ? store.pan_number : "N/A"}
                </span>
              </div>

              <div className="mb-3">
                <p>Location:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {store.location ? store.location : "N/A"}
                </span>
              </div>

              <div className="mb-3">
                <p>Phone:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {store.phone ? store.phone : "N/A"}
                </span>
              </div>

              <div className="mb-3">
                <p>Created By:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  <LetterAvatar name={store.createdBy.name} />
                </span>
              </div>

              <div className="mb-3">
                <p>Updated By:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  <LetterAvatar name={store.updatedBy.name} />
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>No Supplier data found.</div>
      )}
    </div>
  )
}
function StoreTable() {
  const { data: response, isLoading } = useCustomQuery(["order"], "order")
  const { openDialog } = useCrudContext()

  return (
    <>
      <DetailTable
        label="Orders"
        columns={columns}
        data={response?.data.data}
        isLoading={isLoading}
        apiPath="order"
      />
    </>
  )
}

export default StoreDetails
